import React, {
  useRef, useEffect, useState, ChangeEvent,
} from 'react';
import { FiSearch } from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../Hooks/useFetch';
import styles from './Search.module.scss';

const Search = () => {
  const location = useLocation();
  const [searchString, setSearchString] = useState('');
  const { state: products } = useFetch(`${process.env.REACT_APP_BASE_URL}/products`);
  const [searchResults, setSearchResults] = useState([]);

  const searchRef = useRef<any>();
  const handleFocus = () => {
    searchRef.current.focus();
  };

  const handleSearch = (e:ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === '') {
      setSearchString('');
      setSearchResults([]);
      return;
    }
    const lowerCaseSearchString = e.target.value.toLowerCase();
    setSearchString(lowerCaseSearchString);
    const newSearchResults = products.filter(({ title }: { title: string }) => {
      const lowerCaseTitle = title.toLowerCase();
      return lowerCaseTitle.includes(lowerCaseSearchString);
    });
    setSearchResults(newSearchResults);
  };

  useEffect(() => () => {
    setSearchString('');
    setSearchResults([]);
  }, [location]);

  return (
    <div className={styles.searchBox} onClick={handleFocus} aria-hidden>
      <FiSearch />
      <input type="text" ref={searchRef} value={searchString} onChange={handleSearch} placeholder="Search for products.." />
      {
        !!searchResults.length
        && (
          <div className={styles.searchResults}>
            {
              searchResults.map(({ title, id }) => (
                <div>
                  <Link to={`/product-details/${id}`} className={styles.link}>
                    {title}
                  </Link>
                </div>
              ))
            }
          </div>
        )
      }
    </div>
  );
};

export default Search;
